import React, { useContext } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { UserContext } from "./Context/UserContext";

export default function SubmenuHeader({ selectedMenu }) {
  const { allPermiss } = useContext(UserContext);
  const location = useLocation();
  return (
    <>
      {selectedMenu && (
        <div className="flex gap-1 items-center px-2 bg-white border-b-2 border-b-violet-200 w-full py-1.5 sticky top-8 left-0 z-30">
          <div className="font-bold">
            {/* {menu.label}{" "} */}
            {selectedMenu.label}&gt;
          </div>
          <div className="flex gap-1 md:gap-2 flex-wrap">
            {selectedMenu.submenu.map((submenuItem, index) => (
              <>
                {/* {allPermiss.includes(
                  submenuItem.slug_create || submenuItem.slug_view
                ) && ( */}
                  <Link
                    to={submenuItem.path}
                    key={submenuItem.id}
                    style={{ textDecoration: "none" }}
                    className="flex gap-1"
                  >
                    <span
                      className={`border-2 px-2 py-0.5 rounded-full font-medium ${
                        location.pathname === submenuItem.path
                          ? "bg-blue-600 border-blue-700 text-white"
                          : "bg-orange-100 border-orange-200 active:bg-orange-300 hover:bg-orange-50 text-black hover:text-black"
                      }`}
                    >
                      {submenuItem.label}
                    </span>
                  </Link>
                {/* )} */}
              </>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
